var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconAlert(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.999 15.25L12.1157 15.2567C12.6134 15.3144 13 15.7367 13 16.25C13 16.8022 12.5522 17.25 12 17.25C11.4478 17.25 11 16.8022 11 16.2554C10.9963 15.7375 11.3874 15.3105 11.8898 15.2559L11.999 15.25Z",
    fill: "#9B2C2C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7432 7.39823C12.6935 7.03215 12.3797 6.75 12 6.75C11.5858 6.75 11.25 7.08579 11.25 7.5V12.5L11.2568 12.6018C11.3065 12.9678 11.6203 13.25 12 13.25C12.4142 13.25 12.75 12.9142 12.75 12.5V7.5L12.7432 7.39823Z",
    fill: "#9B2C2C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.88367 3.05567C7.39932 2.54002 8.09908 2.25 8.828 2.25H15.171C15.8999 2.25 16.5997 2.54002 17.1153 3.05567L20.9426 6.88296C21.4595 7.39849 21.75 8.09848 21.75 8.828V15.171C21.75 15.8999 21.46 16.5997 20.9444 17.1153L16.5304 21.5303C16.3897 21.671 16.1989 21.75 16 21.75H8.828C8.09908 21.75 7.39932 21.46 6.88367 20.9443L3.05567 17.1163C2.54002 16.6007 2.25 15.9009 2.25 15.172V8.828C2.25 8.09908 2.54002 7.39932 3.05567 6.88367L6.88367 3.05567ZM16.0547 4.11633C15.8202 3.88191 15.502 3.75 15.171 3.75H8.828C8.49702 3.75 8.17875 3.88191 7.94433 4.11633L4.11633 7.94433C3.88191 8.17875 3.75 8.49702 3.75 8.828V15.172C3.75 15.503 3.88191 15.8212 4.11633 16.0557L7.94433 19.8837C8.17875 20.1181 8.49702 20.25 8.828 20.25H15.688L19.8837 16.0547C20.0846 15.8537 20.2102 15.5912 20.242 15.3119L20.25 15.171V8.828C20.25 8.49699 20.1181 8.17913 19.8827 7.94433L16.0547 4.11633Z",
    fill: "#9B2C2C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAlert);
export default __webpack_public_path__ + "static/media/icon_alert.b97ca556.svg";
export { ForwardRef as ReactComponent };